export default __webpack_public_path__ + "06113bf748ae7dc33e05189a90815625.ttf";